import React, {Component} from 'react';
import PropTypes from 'prop-types';
import FileViewerModal from "./FileViewerModal";
import './PdfViewerModal.css'
import BackEnd from "../backend/BackEnd";

const $ = window.jQuery;

class PdfViewerModal extends Component {
    static propTypes = {
        documentUrl: PropTypes.string,
        documentId: PropTypes.number,
        show: PropTypes.bool.isRequired,
        onHide: PropTypes.func.isRequired
    };

    render() {
        return (
            <FileViewerModal {...this.props}
                             requireToken={!this.props.allowAnonymous}
                             createUrl={
                                 this.props.allowAnonymous
                                     ? () => (new BackEnd.Documents.ViewAnonymous()).createUrl({documentId: this.props.documentId})
                                     : null
                             }
                             viewer={url => {
                                 const height = $(window).height() - 250;
                                 return (
                                     <iframe className="pdf-viewer" height={height}
                                             src={url}
                                             type="application/pdf"/>
                                 );
                             }}/>
        );
    }
}

export default PdfViewerModal;


// WEBPACK FOOTER //
// ./src/modals/PdfViewerModal.js